<script>
import layout from '@src/mixins/layout.vue'

import NavigateMixin from '@src/mixins/navigate-mixin.vue'

export default {
  mixins: [layout, NavigateMixin],
  emits: ['close-dialog'],
  props: {
    showAlert: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return { isAlert: this.showAlert }
  },
  mounted: function () {
    this.isAlert = this.showAlert
  },
  methods: {
    dismissAlert() {
      this.isAlert = false
      this.$emit('close-dialog')
    },
    startChat() {
      this.isAlert = false
      this.$emit('proceed')
    },
  },
}
</script>

<template>
  <v-row justify="center">
    <v-dialog
      v-model="isAlert"
      scrollable
      persistent
      min-width="200"
      max-width="400"
      no-click-animation
      transition="fade-transition"
      :content-class="'elevation-0' + ' ' + $style.dialogMenu"
      :fullscreen="mobile"
    >
      <v-card :class="$style.dialogContainer">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dismissAlert">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text :class="$style.chatContainer" class="text-center">
          <div class="mb-7">
            <p :class="$style.alertText">
              During chat session, your personal health information may be
              securely shared with the provider.
              <router-link
                :class="$style.privacyText"
                :to="{ name: 'healthbookplus-privacy' }"
                >View Privacy Policy</router-link
              >
            </p>
          </div>
          <v-row :class="$style.buttonContainer">
            <div class="pa-3">
              <a
                class="clickable primary--text"
                :class="$style.hrRouterLinkText"
                @click="dismissAlert"
              >
                Go back
              </a>
            </div>
            <div :class="$style.vl" />

            <div class="pa-3">
              <a
                class="clickable primary--text"
                :class="$style.hrRouterLinkTextStrong"
                @click="startChat"
              >
                Proceed
              </a>
            </div>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<style lang="scss" module>
@import '@design';

.dialogMenu {
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.5);
}

.dialogContainer {
  background-color: #fff !important;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.5);
}

.chatContainer {
  margin-top: 0;
}

.privacyText {
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  color: #0476d9;
  text-align: left;
  text-decoration: none;
  letter-spacing: 0;
}

.alertText {
  font-size: 16px;
  font-weight: 400;
  line-height: 30px;
  color: black;
  text-align: left;
}

.buttonContainer {
  align-items: center;
}

.vl {
  height: 20px;
  border-left: 3px solid rgb(206, 206, 206);
}

.hrRouterLinkTextStrong {
  font-size: 18px;
  font-weight: 800;
}

.hrRouterLinkText {
  font-size: 18px;
}

@media screen and (max-width: 600px) {
  .chatContainer {
    margin-top: 50%;
  }
}
</style>
